export default (function () {
  // slideUp
  const slideUp = (el, duration = 300) => {
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("padding-top");
      el.style.removeProperty("padding-bottom");
      el.style.removeProperty("margin-top");
      el.style.removeProperty("margin-bottom");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  };

  // slideDown
  const slideDown = (el, duration = 300) => {
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") {
      display = "block";
    }
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.height = height + "px";
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.setAttribute("aria-hidden", "false");
    setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  };

  // ボタン
  // const slideUpBtn = document.querySelector(".slide-up-btn");
  // const slideDownBtn = document.querySelector(".slide-down-btn");
  const slideToggleBtn = document.querySelectorAll(".js-accordion");

  // slideToggle
  const slideToggle = (el, duration = 300) => {
    if (window.getComputedStyle(el).display === "none") {
      el.previousElementSibling.classList.add("is-open");
      return slideDown(el, duration);
    } else {
      el.previousElementSibling.classList.remove("is-open");
      return slideUp(el, duration);
    }
  };

  // // slideUp
  // slideUpBtn.addEventListener("click", () => {
  //   slideUp(el, 300);
  // });

  // // slideDown
  // slideDownBtn.addEventListener("click", () => {
  //   slideDown(el, 300);
  // });

  // slideToggle
  if (slideToggleBtn != undefined && slideToggleBtn != null) {
    slideToggleBtn.forEach((btn) => {
      if (btn.nextElementSibling != null) {
        btn.nextElementSibling.style.display = "none";

        btn.addEventListener("click", () => {
          let el = btn.nextElementSibling;
          slideToggle(el, 300);
        });
      }
    });
  }
})();
